import darkPlace from '@/assets/img/users-cases/dark-place.webp';
import darkPlaceHow from '@/assets/img/users-cases/dark-place-how.webp';
import darkPlaceResult from '@/assets/img/users-cases/dark-place-result.webp';

export default {
  slug: 'dark-place',
  order: 17,
  title: 'Dark Interior 3D Experience',
  subtitle: 'Atmospheric 3D renderings with cinematic lighting',
  tags: ['InteriorDesign', 'Layouts'],

  images: {
    hero: darkPlace,
    aboutTop: darkPlaceHow,
    aboutBottom: darkPlaceResult,
  },

  howText:
    'We worked out 2D and 3D layouts and interior design, paying special attention to lighting scenarios and materials suitable for marketing visualization.',

  resultText:
    'The visuals are used across brochures, presentations, and digital marketing channels.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
